
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoSupplierGrid extends Serenity.EntityGrid<PoSupplierRow, any> {
        protected getColumnsKey() { return PoSupplierColumns.columnsKey; }
        protected getDialogType() { return PoSupplierDialog; }
        protected getIdProperty() { return PoSupplierRow.idProperty; }
        protected getInsertPermission() { return PoSupplierRow.insertPermission; }
        protected getLocalTextPrefix() { return PoSupplierRow.localTextPrefix; }
        protected getService() { return PoSupplierService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PoSupplierService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
           
                buttons.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
            

            return buttons;
        }            
           
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["  "]);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }
    }
}